export default {
  common: {
    nav: {
      home: "หน้าแรก",
      find_offer_help: "หา / เสนอความช่วยเหลือ",
      celebrate: "รำลึกชีวิต",
      family_tree: "แผนผังครอบครัว",
      events: "กิจกรรม",
      civic_reports: "รายงานพลเมือง",
      neighborhood_pulse: "จังหวะย่าน",
      weather: "อากาศ",
      nature: "ธรรมชาติ",
      marketplace: "ตลาด",
      news: "ข่าว",
      causes: "จุดมุ่งหมาย",
      more: "เพิ่มเติม",
    },
    header: { sign_in: "เข้าสู่ระบบ", join: "เข้าร่วม Social Pulse", language: "ภาษา", search: "ค้นหา" },
    tagline: "เชื่อมโยงชุมชน · เสริมพลังชีวิต · สร้างทุนทางสังคม",
    locality: { viewing_from: "คุณกำลังดูจาก", change: "เปลี่ยน", set_your_location: "ตั้งตำแหน่งของคุณ" },
    news: { title: "สรุปข่าวประจำวัน", play_briefing: "เล่นสรุปข่าวประจำวัน", listen: "ฟัง", translate: "แปล" },
  },
};
